angular.module("alerts", [])
   .service("alerts", ["$timeout", function($timeout){
      var Alerts = {
         _alerts : [],
         _id : 0,
         success : function(message, duration){
            this.alert("success", message, duration);
         },
         info : function(message, duration){
            this.alert("info", message, duration);
         },
         warning : function(message, duration){
            this.alert("warning", message, duration);
         },
         danger : function(message, duration){
            this.alert("danger", message, duration);
         },
         alert : function(type, message, duration){
            if (!duration)
               duration = Alerts.DEFAULT;
            var id = this._id++;
            var self = this;
            this._alerts.push({
               id  : id,
               type : type,
               message : message,
               remove : function(){
                  self.remove(id);
               }
            });
            
            $timeout(function(){
               self.remove(id);
            }, duration);
         },
         remove : function(id){
            this._alerts = this._alerts.filter(function(x){
               return x.id != id;
            });
         }
      };
      Alerts.LONG = 4000;
      Alerts.DEFAULT = 2000;
      Alerts.SHORT = 1000;
      return Alerts;
   }])

   .directive("alerts", function(){
      return {
         templateUrl: "alerts/tmpl/alerts.tmpl.html",
         controller: ["$scope", "alerts", function($scope, alerts){
            $scope.alerts = alerts;
         }]
      };
   });
angular.module("alerts").run(["$templateCache", function($templateCache) {$templateCache.put("alerts/tmpl/alerts.tmpl.html","<div class=\"alerts\">\r\n	<div data-ng-repeat=\"alert in alerts._alerts track by alert.id\" class=\"alert alert-{{alert.type}} alert-dismissible\">\r\n		 <button type=\"button\" class=\"close\" data-dismiss=\"alert\" data-ng-click=\"alert.remove()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button>\r\n		 {{alert.message}}\r\n	</div>\r\n</div>");}]);